import PropTypes from 'prop-types';

export default {
  hideCancellationPolicies: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ])
};
